import { ImageCell } from '@/components/shared/ImageCell';
import type { GreaterArea } from '@/config/objects/greater-areas';

interface GreaterAreaImageCellProps {
  greaterArea?: GreaterArea;
  size?: 'sm' | 'lg';
}

/**
 * Editable greater area image cell component with upload and delete actions
 */
export function GreaterAreaImageCell({ greaterArea, size = 'sm' }: GreaterAreaImageCellProps) {
  return (
    <ImageCell
      item={greaterArea}
      endpoint="/greater-areas"
      entityName="Greater Area"
      imageLabel="Greater Area Image"
      getFeaturedImage={(item) => item.featuredImage}
      getItemId={(item) => item.id}
      size={size}
    />
  );
}
